
export default function DetailMetaList({ items, columns = 2 }) {
	const rows = (items ?? []).filter(
		(row) => row?.value != null && String(row.value).trim() !== ""
	);

	if (rows.length === 0) {
		return null;
	}

	return (
		<dl
			className={[
				"grid gap-3",
				columns === 1 ? "grid-cols-1" : "grid-cols-1 sm:grid-cols-2",
			].join(" ")}
		>
			{rows.map((row) => (
				<div
					key={row.label}
					className="rounded-[10px] bg-lightCta/70 px-3 py-2.5 text-right"
				>
					<dt className="font-Vazir-400 text-[12px] text-darkBlue/50">
						{row.label}
					</dt>
					<dd
						className="mt-0.5 font-Vazir-600 text-[14px] text-darkBlue"
						dir={row.dir ?? "rtl"}
					>
						{row.value}
					</dd>
				</div>
			))}
		</dl>
	);
}
